export default class Search {
    constructor(component) {
        this.component = component;
        this.searchTrigger = this.component.querySelector('[data-menu-search-button]');
        this.searchInput = this.component.querySelector('[data-menu-search-input]');
        
        this.init();
    }

    init() {
        this.searchTrigger.addEventListener('click', () => {
            if (this.searchInput) this.searchInput.focus();
        })
    }
}